/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { providers } from "dc-core";

export const withKeyboardShortcutLabel = (id, WrappedComp) => props => {
  const [shortcutLabel, setShortcutLabel] = React.useState();
  const [shortcutLabels, setShortcutLabels] = React.useState();

  React.useEffect(() => {
    providers["keyboard-shortcuts-provider"]().then(keyboardShortcutProvider => {
      if (Array.isArray(id)) {
        setShortcutLabels(
          id.reduce((acc, i) => {
            const label = keyboardShortcutProvider.getShortcutDisplayLabel(i);
            acc[i] = label;
            return acc;
          }, {})
        );
        return;
      }
      setShortcutLabel(keyboardShortcutProvider.getShortcutDisplayLabel(id));
    });
  }, []);

  const otherProps = { shortcutLabel, shortcutLabels };
  return <WrappedComp {...props} {...otherProps} />;
};
